<template>
  <modal-form-helper :data="{title: 'Search', isModal: true}" :form="post">
  	<template #title></template>
    <template #body>
      <div class="d-flex align-items-center position-relative my-1">
        <span class="svg-icon svg-icon-1 position-absolute ms-6"><i class="fa fa-search"></i></span>
        <input v-model="search_keyword"  type="text" @input="searchDebounced"
               placeholder="Search.." class="form-control form-control-solid ps-14"/>
      </div>
      <div class="my-4">
        <ul class="list-group buyer-list">
          <li v-if="$isProperModule('project')" style="cursor: pointer;" v-for="(project, index) in projects[0]"
              class="list-group-item d-flex justify-content-between align-items-center" @click="close">
            <router-link :to="project.hide_buyer_tracker ? (($_.map(project.team_members, ({id}) => id).includes($user.id))  || overrideHiddenBuyerTracker ? {name: 'project_details', params: {id: project.id}} : '') : {name: 'project_details', params: {id: project.id}}"
                       class="dm-fs-1-1-rem fw-bolder mb-1 text-gray-500 text-hover-primary">
                       {{ project.name }}
          	</router-link>
          	<span>Project</span>
          </li>

          <li v-if="$isProperModule('project')" style="cursor: pointer;" v-for="(comp, index) in company"
              class="list-group-item d-flex justify-content-between align-items-center"  @click="close">
            <router-link :to="{name: 'company_details', params: {id: comp.id, module: $module}}" style="color: inherit"
                       class="text-hover-primary">
            {{ comp.name }}
          </router-link>
          <span>Company</span>
          </li>
          <li v-if="$isProperModule('project')" style="cursor: pointer;color:gray" v-for="(people, index) in peoples"
              class="list-group-item d-flex justify-content-between align-items-center"  @click="close">
            
          <a class="text-hover-primary text-gray-500" style="color: gray !important;">{{people.name}}</a>
          <span>People</span>
          </li>

          <li v-if="$isProperModule('crm')" style="cursor: pointer; color:rgb(7 116 7);" v-for="(opportunity, index) in opportunities"
              class="list-group-item d-flex justify-content-between align-items-center" @click="close">
            <router-link :to="{name: 'crm_opportunity_details', params: {id: opportunity.id}}"
                       class="text-hover-primary text-green-500"  style="color:rgb(7 116 7) !important;">{{ opportunity.title }}
          	</router-link>
          	<span>Opportunity</span>
          </li>

          <li v-if="$isProperModule('crm')" style="cursor: pointer;color:gray" v-for="(comp, index) in company"
              class="list-group-item d-flex justify-content-between align-items-center"  @click="close">
            <router-link :to="{name: 'company_details', params: {id: comp.id, module: $module}}" style="color: gray !important;"
                       class="text-hover-primary text-gray-500">
            {{ comp.name }}
          </router-link>
          <span>Company</span>
          </li>
          <li v-if="$isProperModule('crm')" style="cursor: pointer;color:gray" v-for="(people, index) in peoples"
              class="list-group-item d-flex justify-content-between align-items-center"  @click="close">
            
          <a class="text-hover-primary text-gray-500" style="color: gray !important;">{{people.name}}</a>
          <span>People</span>
          </li>

        </ul>
      </div>
    </template>
    <template #footer>
      ''
    </template>
  </modal-form-helper>
</template>

<script>

export default {
  //Used for both project and pitchbook
  name: "SearchGlobalModal",
  props: {
    project: '',
    modules: '',
    create_event: '',
  },
  data() {
    return {
      search_keyword: "",
      projects: [],
      company: [],
      opportunities: [],
      peoples : [],
      selectedItems: [],
      loading: false,
      post: new Form({})
    }
  },
  computed: {
    inputPlaceholder() {
      const maxLength = 20;

      if (this.search_keyword.length > maxLength) {
        return `${this.search_keyword.slice(0, maxLength)}...`;
      }
      return "this.search_keyword || Search..";
    },
  },
  methods: {
  	fetchGlobalSearch(){
      this.startCompLoading()
      this.$axios.get(this.getUrl('projects', 'projects_global_search'), 
      	{
      		params: {search:this.search_keyword, modules: this.modules}
      	}).then(({data}) => {
            console.log(data)
            this.projects = data.projects
            this.company = data.company
            this.opportunities = data.opportunities
            this.peoples = data.peoples
            this.endCompLoading()
          })
          .catch(err => {
            this.toastLaraValidation(err)
            this.endCompLoading()
          })
    },

    close() {
    	console.log('hear')
      this.$emit('close')
    },
  },
  created() {
    this.searchDebounced = _.debounce(() => this.fetchGlobalSearch(), this.SEARCH_DEBOUNCE_MS)
  },
  mounted() {
    
  }
}
</script>